import { createListenerMiddleware } from '@reduxjs/toolkit';
import { matchPath } from 'react-router-dom';

import type { RootState } from 'reduxStore';
import { endChat } from 'api/resources/chat';
import type { ChatV2State } from './chatV2Slice';

type EnvKey = Exclude<keyof ChatV2State, 'draftArtifactVersions'>;

const CLIENT_ENVS: EnvKey[] = ['draft', 'sandbox', 'pre-release', 'live'];

function getProjectRouteFromUrl(): {
  accountId: string;
  projectId: string;
} | null {
  const match = matchPath('/:accountId/:projectId/*', window.location.pathname);
  if (!match?.params.accountId || !match?.params.projectId) return null;
  return {
    accountId: match.params.accountId,
    projectId: match.params.projectId,
  };
}

export const chatV2ListenerMiddleware = createListenerMiddleware<RootState>();

chatV2ListenerMiddleware.startListening({
  predicate: (_action, currentState, previousState) => {
    return CLIENT_ENVS.some(env => {
      const prev = previousState.chatV2[env].conversationId;
      const curr = currentState.chatV2[env].conversationId;
      return prev != null && curr == null;
    });
  },
  effect: async (_action, listenerApi) => {
    const previousState = listenerApi.getOriginalState() as RootState;
    const currentState = listenerApi.getState() as RootState;
    const route = getProjectRouteFromUrl();
    if (!route) return;

    for (const env of CLIENT_ENVS) {
      const prevConvId = previousState.chatV2[env].conversationId;
      const currConvId = currentState.chatV2[env].conversationId;
      const prevStatus = previousState.chatV2[env].status;

      if (
        prevConvId &&
        !currConvId &&
        prevStatus !== 'ended' &&
        prevStatus !== 'idle'
      ) {
        endChat({
          accountId: route.accountId,
          projectId: route.projectId,
          conversationId: prevConvId,
          clientEnv: env,
          languageCode: previousState.chatV2[env].asrLanguageCode || '',
        }).catch(() => {});
      }
    }
  },
});
